jQuery(document).ready(function($) {
  if (typeof dataLayer !== 'undefined') {
    let products = [];
    $('.add_cart').each(function () {
      products.push($(this).val());
    });

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'get-products',
        'products': products
      }
    }).done( function (response) {
      dataLayer.push({
        'event': 'productImpression',
        'ecommerce': {
          'currencyCode': 'EUR',
          'impressions': [response]
        }
      });
    });
  }
});
